import React from 'react';
import { useParams } from 'react-router-dom';
import useApplicationDetails from 'screens/Applications&WorkOrders/Applications/Hooks/useApplicationDetails';
import applicationNotification from 'screens/Applications&WorkOrders/Applications/Components/Notification';
import ExportOperationPdf from 'screens/Applications&WorkOrders/Components/ExportOperationPdf';
import { OperationType } from 'components/RecordsListView/constants';

interface RouteParams {
  applicationId: string;
}

const ExportApplicationPdf: React.FC = () => {
  const { applicationId } = useParams<RouteParams>();

  const {
    applicationDetails,
    isLoading: isLoadingDetails,
    errors
  } = useApplicationDetails(applicationId ?? '');

  return (
    <ExportOperationPdf
      operationType={OperationType.APPLICATION}
      operationId={applicationId}
      operationDetails={applicationDetails}
      isLoadingDetails={isLoadingDetails}
      errors={errors}
      notification={applicationNotification}
    />
  );
};

export default ExportApplicationPdf;
